import { render, staticRenderFns } from "./AboutZh.vue?vue&type=template&id=659ed858&scoped=true&"
import script from "./AboutZh.vue?vue&type=script&lang=js&"
export * from "./AboutZh.vue?vue&type=script&lang=js&"
import style0 from "./AboutZh.vue?vue&type=style&index=0&id=659ed858&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659ed858",
  null
  
)

export default component.exports